import { Fragment, useState } from 'react';
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Mixedchart from "../charts/Mixedchart";
import { formatNumberShort } from "components/Function";
import TimeRanger from "../../ui/timeRanger";

function Overview({ detail, overview, sale_overview, follower_trending, digg_trending, video_overview, live_overview, filter, setFilter }) {
    const { t } = useTranslation();
    const [sale_overview_videos, setSaleOverviewVideos] = useState(false);
    const [sale_overview_lives, setSaleOverviewLives] = useState(false);

    const onChange = (e) => {
        if (e.target.name === "sale_overview_videos") {
            setSaleOverviewVideos(e.target.checked);
        }
        if (e.target.name === "sale_overview_lives") {
            setSaleOverviewLives(e.target.checked);
        }
    };

    return (
        <Fragment>
            <div className="card mt-5 mb-5 mb-xl-10">
                <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_profile_details" aria-expanded="true" aria-controls="kt_account_profile_details">
                    <div className="card-title m-0">
                        <h3 className="fw-bold m-0">{t("Overview")} ({(filter.dateRange || "30") + " days"})</h3>
                    </div>
                    <div className="col-md-3 position-relative my-5">
                        <div className="d-flex flex-column">
                            <TimeRanger filter={filter} setFilter={setFilter} />
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center gap-8 m-4 px-20">
                        {overview?.map((v, k) => (
                            <Fragment key={k}>
                                <div className="text-center">
                                    <div className="fw-bold fs-2">
                                        {v?.prefix}{formatNumberShort(v?.value)}
                                    </div>
                                    <div className="text-muted small">{v?.label}</div>
                                </div>
                                {overview.length !== k + 1 && <div className="vr"></div>}
                            </Fragment>
                        ))}
                    </div>
                    <div className="d-flex justify-content-between mt-15">
                        <div>
                            <h3 className="fw-bold m-0">
                                {t("Last")} {(filter.dateRange || "30")} {t("day videos")}
                            </h3>
                        </div>
                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                            <div className="form-check form-check-solid form-switch form-check-custom fv-row">
                                <input type="checkbox" className="form-check-input w-45px h-30px" value={!sale_overview_videos} id="sale_overview_videos" name="sale_overview_videos" checked={sale_overview_videos} onChange={(e) => { onChange(e) }} />
                                <label className="form-check-label" htmlFor="sale_overview_videos">{t("Shoppable videos only")}</label>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center gap-8 m-4 px-20">
                        {sale_overview?.[sale_overview_videos ? "sales" : "basic"]?.video?.map((v, k) => (
                            <Fragment key={k}>
                                <div className="text-center">
                                    <div className="fw-bold fs-2">
                                        {v?.prefix}{formatNumberShort(v?.value)}{v?.value !== "-" ? v?.suffix : ""}
                                    </div>
                                    <div className="text-muted small">{v?.label}</div>
                                </div>
                                {sale_overview?.[sale_overview_videos ? "sales" : "basic"]?.video.length !== k + 1 && <div className="vr"></div>}
                            </Fragment>
                        ))}
                    </div>
                    <div className="d-flex justify-content-between mt-15">
                        <div>
                            <h3 className="fw-bold m-0">
                                {t("Last")} {(filter.dateRange || "30")} {t("day lives")}
                            </h3>
                        </div>
                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                            <div className="form-check form-check-solid form-switch form-check-custom fv-row">
                                <input type="checkbox" className="form-check-input w-45px h-30px" value={!sale_overview_lives} id="sale_overview_lives" name="sale_overview_lives" checked={sale_overview_lives} onChange={(e) => { onChange(e) }} />
                                <label className="form-check-label" htmlFor="sale_overview_lives">{t("Shoppable videos only")}</label>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center gap-8 m-4 px-20">
                        {sale_overview?.[sale_overview_lives ? "sales" : "basic"]?.live?.map((v, k) => (
                            <Fragment key={k}>
                                <div className="text-center">
                                    <div className="fw-bold fs-2">
                                        {v?.prefix}{formatNumberShort(v?.value)}{v?.value !== "-" ? v?.suffix : ""}
                                    </div>
                                    <div className="text-muted small">{v?.label}</div>
                                </div>
                                {sale_overview?.[sale_overview_lives ? "sales" : "basic"]?.live.length !== k + 1 && <div className="vr"></div>}
                            </Fragment>
                        ))}
                    </div>
                    <div className="d-flex justify-content-between mt-15">
                        <div>
                            <h3 className="fw-bold m-0">
                                {t("Trend of followers in the last")} {(filter.dateRange || "30")} {t("days")}
                            </h3>
                        </div>
                    </div>
                    <div className="d-flex mt-10">
                        <div className="d-flex col">
                            <Mixedchart follower_trending={follower_trending} />
                        </div>
                        <div className="d-flex col">
                            <Mixedchart digg_trending={digg_trending} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between mt-15">
                        <div>
                            <h3 className="fw-bold m-0">
                                {t("Trend of contents in the last")} {(filter.dateRange || "30")} {t("days")}
                            </h3>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap w-100 gap-3 mt-5">
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <i className="ki-outline ki-to-right fs-3 text-info me-2 mb-2 py-5"></i><br />
                                <div className="fs-2 fw-bold counted">{video_overview?.total_post_video_30d_cnt}</div>
                                <div className="fw-semibold fs-4">{t("Posted videos")}</div>
                                <div className="fs-8 text-gray-500">{t("Total videos")}: {video_overview?.total_post_video_cnt}</div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <div className="fs-8 text-gray-500 pt-3">{t("Average Duration")}</div>
                                <div className="fs-2 fw-bold counted">{video_overview?.per_video_duration}</div><br/><br/>
                                <div className="fs-8 d-flex justify-content-between border-bottom py-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("Average View")}
                                    </div>
                                    <div className="d-flex">
                                        {video_overview?.per_views_avg_cnt}
                                    </div>
                                </div>
                                <div className="fs-8 d-flex justify-content-between border-bottom py-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("Average Like")}
                                    </div>
                                    <div className="d-flex">
                                        {video_overview?.per_digg_avg_cnt}
                                    </div>
                                </div>
                                <div className="fs-8 d-flex justify-content-between pt-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("Average Comments")}
                                    </div>
                                    <div className="d-flex">
                                        {video_overview?.per_comment_avg_cnt}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <div className="fs-8 text-gray-500 pt-3">{t("Average Sales per video")}</div>
                                <div className="fs-2 fw-bold counted">{video_overview?.per_sales_avg_cnt}</div><br/><br/>
                                <div className="fs-8 d-flex justify-content-between border-bottom py-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("No. of products")}
                                    </div>
                                    <div className="d-flex">
                                        {video_overview?.total_product_30d_cnt}
                                    </div>
                                </div>
                                <div className="fs-8 d-flex justify-content-between pt-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("Total Sales")}
                                    </div>
                                    <div className="d-flex">
                                        {video_overview?.total_new_video_sale_30d_cnt}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <div className="fs-8 text-gray-500 pt-3">{t("Average GMV per video")}</div>
                                <div className="fs-2 fw-bold counted">{video_overview?.per_gmv_avg_amt}</div><br/><br/>
                                <div className="fs-8 d-flex justify-content-between pt-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("Total GMV")}
                                    </div>
                                    <div className="d-flex">
                                        {video_overview?.total_new_video_sale_gmv_30d_amt}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="min-w-200px me-6 mb-3 h-100 d-flex flex-column justify-content-between">
                                <div className="fs-8">{t("Most Viewed")}</div>
                                <div className="d-flex justify-content-between pt-2">
                                    <div className="text-gray-500 d-flex al-border-radius-8 overflow-hidden">
                                        <img src={video_overview?.most_views_30d_video?.cover_url ? video_overview?.most_views_30d_video?.cover_url : require("components/assets/media/misc/thumb_video.png")} alt="" width="120" height="190" />
                                    </div>
                                    <div className="d-flex flex-column justify-content-between">
                                        <div><i className="bi bi-clock"></i> {video_overview?.most_views_30d_video?.duration}</div>
                                        <div><i className="bi bi-play-circle"></i> {video_overview?.most_views_30d_video?.views_count}</div>
                                        <div><i className="bi bi-heart"></i> {video_overview?.most_views_30d_video?.likes_count}</div>
                                        <div><i className="bi bi-chat-square-dots"></i> {video_overview?.most_views_30d_video?.comments_count}</div>
                                        <div><i className="bi bi-box-arrow-up-right"></i> {video_overview?.most_views_30d_video?.shares_count}</div>
                                    </div>
                                </div>
                                <div className="fs-8 text-gray-500 text-truncate" style={{ width: "120px" }} data-tooltip-id="my-tooltip" data-tooltip-html={`<div style="width: 200px">${video_overview?.most_views_30d_video?.video_title}</div>`}>{video_overview?.most_views_30d_video?.video_title_brief}</div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="min-w-200px me-6 mb-3 h-100 d-flex flex-column justify-content-between">
                                <div className="fs-8">{t("Best Sales")}</div>
                                <div className="d-flex justify-content-between pt-2">
                                    <div className="text-gray-500 d-flex al-border-radius-8 overflow-hidden">
                                        <img src={video_overview?.most_gmv_30d_video?.cover_url ? video_overview?.most_gmv_30d_video?.cover_url : require("components/assets/media/misc/thumb_video.png")} alt="" width="120" height="190" />
                                    </div>
                                    <div className="d-flex flex-column justify-content-between">
                                        <div><i className="bi bi-clock"></i> {video_overview?.most_gmv_30d_video?.duration}</div>
                                        <div><i className="bi bi-play-circle"></i> {video_overview?.most_gmv_30d_video?.views_count}</div>
                                        <div><i className="bi bi-heart"></i> {video_overview?.most_gmv_30d_video?.likes_count}</div>
                                        <div><i className="bi bi-chat-square-dots"></i> {video_overview?.most_gmv_30d_video?.comments_count}</div>
                                        <div><i className="bi bi-box-arrow-up-right"></i> {video_overview?.most_gmv_30d_video?.shares_count}</div>
                                    </div>
                                </div>
                                <div className="fs-8 text-gray-500 text-truncate" style={{ width: "120px" }} data-tooltip-id="my-tooltip" data-tooltip-html={`<div style="width: 200px">${video_overview?.most_gmv_30d_video?.video_title}</div>`}>{video_overview?.most_gmv_30d_video?.video_title_brief}</div>
                            </div>
                        </div>
                    </div>
                    { detail?.total_live_cnt > 0 && <div className="d-flex flex-wrap w-100 gap-3 mt-5">
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <i className="ki-outline ki-to-right fs-3 text-info me-2 mb-2 py-5"></i><br />
                                <div className="fs-2 fw-bold counted">{live_overview?.total_live_30d_cnt}</div>
                                <div className="fw-semibold fs-4">{t("Lives in 30 days")}</div>
                                <div className="fs-8 text-gray-500">{t("Total lives")}: {live_overview?.total_live_cnt}</div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <div className="fs-8 text-gray-500 pt-3">{t("Average Duration")}</div>
                                <div className="fs-2 fw-bold counted">{live_overview?.per_live_avg_hour}</div><br/><br/>
                                <div className="fs-8 d-flex justify-content-between border-bottom py-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("Average View")}
                                    </div>
                                    <div className="d-flex">
                                        {live_overview?.per_live_user_avg_cnt}
                                    </div>
                                </div>
                                <div className="fs-8 d-flex justify-content-between border-bottom py-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("Average Like")}
                                    </div>
                                    <div className="d-flex">
                                        {live_overview?.per_digg_avg_cnt}
                                    </div>
                                </div>
                                <div className="fs-8 d-flex justify-content-between pt-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("Average Comments")}
                                    </div>
                                    <div className="d-flex">
                                        {live_overview?.per_comment_avg_cnt}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <div className="fs-8 text-gray-500 pt-3">{t("Average Sales per live")}</div>
                                <div className="fs-2 fw-bold counted">{live_overview?.per_new_live_sale_avg_30d_cnt}</div><br/><br/>
                                <div className="fs-8 d-flex justify-content-between border-bottom py-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("No. of products")}
                                    </div>
                                    <div className="d-flex">
                                        {live_overview?.total_live_product_30d_cnt}
                                    </div>
                                </div>
                                <div className="fs-8 d-flex justify-content-between pt-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("Total Sales")}
                                    </div>
                                    <div className="d-flex">
                                        {live_overview?.total_new_live_sale_30d_cnt}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="bg-light-info al-border-radius-8 min-w-200px py-3 px-4 me-6 mb-3 h-100 d-flex flex-column">
                                <div className="fs-8 text-gray-500 pt-3">{t("Average GMV per live")}</div>
                                <div className="fs-2 fw-bold counted">{live_overview?.per_new_live_sale_gmv_avg_30d_amt}</div><br/><br/>
                                <div className="fs-8 d-flex justify-content-between pt-2">
                                    <div className="text-gray-500 d-flex">
                                        {t("Total GMV")}
                                    </div>
                                    <div className="d-flex">
                                        {live_overview?.total_new_live_sale_gmv_30d_amt}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="min-w-200px me-6 mb-3 h-100 d-flex flex-column justify-content-between">
                                <div className="fs-8">{t("Most Viewed")}</div>
                                <div className="d-flex justify-content-between pt-2">
                                    <div className="text-gray-500 d-flex al-border-radius-8 overflow-hidden">
                                        <img src={live_overview?.most_views_30d_live?.cover_url ? live_overview?.most_views_30d_live?.cover_url : require("components/assets/media/misc/thumb_live.png")} alt="" width="120" height="190" />
                                    </div>
                                    <div className="d-flex flex-column justify-content-between">
                                        <div><i className="bi bi-clock"></i> {live_overview?.most_views_30d_live?.duration}</div>
                                        <div><i className="bi bi-play-circle"></i> {live_overview?.most_views_30d_live?.total_views_cnt}</div>
                                        <div><i className="bi bi-heart"></i> {live_overview?.most_views_30d_live?.max_views_cnt}</div>
                                        <div><i className="bi bi-chat-square-dots"></i> {live_overview?.most_views_30d_live?.total_sale_cnt}</div>
                                        <div><i className="bi bi-box-arrow-up-right"></i> {live_overview?.most_views_30d_live?.total_gmv_amt}</div>
                                    </div>
                                </div>
                                <div className="fs-8 text-gray-500 text-truncate" style={{ width: "120px" }}>{live_overview?.most_views_30d_live?.title}</div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="min-w-200px me-6 mb-3 h-100 d-flex flex-column justify-content-between">
                                <div className="fs-8">{t("Best Sales")}</div>
                                <div className="d-flex justify-content-between pt-2">
                                    <div className="text-gray-500 d-flex al-border-radius-8 overflow-hidden">
                                        <img src={live_overview?.most_gmv_30d_live?.cover_url ? live_overview?.most_gmv_30d_live?.cover_url : require("components/assets/media/misc/thumb_live.png")} alt="" width="120" height="190" />
                                    </div>
                                    <div className="d-flex flex-column justify-content-between">
                                        <div><i className="bi bi-clock"></i> {live_overview?.most_gmv_30d_live?.duration}</div>
                                        <div><i className="bi bi-play-circle"></i> {live_overview?.most_gmv_30d_live?.total_views_cnt}</div>
                                        <div><i className="bi bi-heart"></i> {live_overview?.most_gmv_30d_live?.max_views_cnt}</div>
                                        <div><i className="bi bi-chat-square-dots"></i> {live_overview?.most_gmv_30d_live?.total_sale_cnt}</div>
                                        <div><i className="bi bi-box-arrow-up-right"></i> {live_overview?.most_gmv_30d_live?.total_gmv_amt}</div>
                                    </div>
                                </div>
                                <div className="fs-8 text-gray-500 text-truncate" style={{ width: "120px" }}>{live_overview?.most_gmv_30d_live?.title}</div>
                            </div>
                        </div>
                    </div> }
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Overview);